import React from 'react';
import connect from "react-redux/es/connect/connect";
import {fetchLocations} from "../../../state/modules/locations";
import {updateList} from "../../../state/modules/resources";
import FilterGroup from "../filter-group";
import EnumFilter from "../enum-filter";

class LocationFilter extends React.Component {

    componentDidMount() {
        if (!this.props.locations) {
            this.props.fetchLocations();
        }
        
        if (this.props.setDefaultFromRegister && this.props.activeRegister && this.props.activeRegister.location) {
            const list = this.props.lists[this.props.listId];
            
            if (list && (!list.filters || !list.filters[this.props.filterKey || 'filter_location'])) {
                const locationId = this.props.activeRegister.location;
                const locationName = this.props.activeRegister.location ? this.props.activeRegister.location.name : '';
                
                this.props.updateList(this.props.listId, {
                    filters: {
                        [this.props.filterKey || 'filter_location']: [{key: locationId, value: locationName}]
                    }
                });
            }
        }
    }

    render() {
        if (!this.props.locations) {
            return null;
        }
        
        let locations = {};
        this.props.locations.forEach(location => {
            locations[Number(location.id)] = location.name;
        });

        return (
            <FilterGroup title="Location">
                <EnumFilter 
                    listId={this.props.listId} 
                    filterKey={this.props.filterKey || 'filter_location'} 
                    options={locations}
                    multiple={false}
                />
            </FilterGroup>
        );
    }
}

const mapStateToProps = (state) => ({
    locations: state.locations.locations,
    activeRegister: state.register.activeRegister,
    lists: state.resources.lists
});

const mapDispatchToProps = {
    fetchLocations: fetchLocations,
    updateList: updateList
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationFilter);
